<template>
  <v-app>
    <v-overlay 
      v-if="loader"
      style="z-index:7"
      class="text-center"
    >
      <v-progress-circular
        indeterminate
        size="50"
      />
      <h4 class="my-2">Đang chuẩn bị dữ liệu</h4>
    </v-overlay>
    <v-app-bar
      app
      fixed
      color="white"
      elevate-on-scroll
    >
      <v-app-bar-nav-icon 
        v-if="!$vuetify.breakpoint.lgAndUp"
        @click.stop="drawerMobile = !drawerMobile"
      />

      <v-app-bar-nav-icon 
        v-if="$vuetify.breakpoint.lgAndUp"
        @click.stop="drawer = !drawer"
      >
        <v-icon>mdi-{{ drawer ? 'menu-open' : 'menu' }} </v-icon>
      </v-app-bar-nav-icon>

      <v-toolbar-title 
        v-if="$vuetify.breakpoint.lgAndUp"
        class="text-center pl-0"
      >
        <div
          class="font-weight-regular black--text" 
          style="text-transform: capitalize;"
        >
          {{sysName}} {{config.provinceName}}
        </div>
      </v-toolbar-title>
      <v-spacer v-if="!$vuetify.breakpoint.lgAndUp"/>
      <router-link to="/">
        <v-img
          v-if="!$vuetify.breakpoint.lgAndUp"
          alt="Agri portal Logo"
          class="shrink ml-2"
          contain
          src="@/assets/agriportal-logo-v2.png"
          transition="scale-transition"
          :width="45"
        />
      </router-link>
      <v-spacer/>
      <template v-if="!isLogged">
        <v-list 
          v-if="$vuetify.breakpoint.lgAndUp"
          rounded class="py-0"
        >
          <v-list-item @click="login">
            <v-list-item-avatar class="mr-2">
              <v-img src="@/assets/user-default.jpg"/>
            </v-list-item-avatar>
            <v-list-item-title>Đăng nhập</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list v-else class="py-0">
          <v-list-item @click="login" class="pa-0">
            <v-img src="@/assets/user-default.jpg" width="30"/>
          </v-list-item>
        </v-list>
      </template>
      <template v-else>
        <v-badge
          v-if="isChuyenGia"
          top
          right
          color="error"
          :content="qasNotRespCounter > 0 ? qasNotRespCounter : '0'"
          offset-x="20"
          offset-y="20"
        >
          <v-btn icon elevation="1"
            to="/expert/mail-box"
          >
            <v-icon :class="{ 'bounce': qasNotRespCounter > 0 }">mdi-bell-ring-outline</v-icon>
          </v-btn>
        </v-badge>
        <v-badge
          v-if="$can('lien-he-xem') && $vuetify.breakpoint.lgAndUp"
          top
          right
          color="error"
          :content="contactCounter > 0 ? contactCounter : '0'"
          offset-x="20"
          offset-y="20"
        >
          <v-btn icon elevation="0"
            :to="{path: '/admin/contacts'}"
          >
            <v-icon :class="{ 'bounce': contactCounter > 0 }">mdi-bell-ring-outline</v-icon>
          </v-btn>
        </v-badge>
        <v-menu offset-y="offset-y">
          <template v-slot:activator="{ on }">
            <v-list 
              v-if="$vuetify.breakpoint.lgAndUp" 
              rounded 
              class="py-0"
            >
              <v-list-item v-on="on">
                <v-list-item-avatar class="mr-2">
                  <v-img 
                    v-if="authMod.user.user.info.anh_dai_dien" 
                    :src="`${apiBaseUrl}/uploads/${authMod.user.user.info.anh_dai_dien}`"
                  />
                  <v-img v-else src="@/assets/user-default.jpg"/>
                </v-list-item-avatar>
                <v-list-item-title class="text-capitalize">{{authMod.user.user.name}}</v-list-item-title>
                <v-icon>mdi-chevron-down</v-icon>
              </v-list-item>
            </v-list>
            <v-list v-else class="py-0">
              <v-list-item v-on="on" class="pa-0">
                <v-img src="@/assets/user-default.jpg" width="30"/>
              </v-list-item>
            </v-list>
          </template>
          <v-list nav dense>
            <template>
              <v-list-item 
                v-if="!$role('user')"
                :to="{name: adminRouteName}"
              >
                <v-list-item-icon>
                  <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Trang quản trị</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="showProfileDialog">
                <v-list-item-icon>
                  <v-icon>mdi-account-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Thông tin cá nhân</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="changePassword">
                <v-list-item-icon>
                  <v-icon>mdi-lock-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Đổi mật khẩu</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="logout()">
                <v-list-item-icon>
                  <v-icon>mdi-power</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Đăng xuất</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </v-app-bar>
    <v-navigation-drawer 
      v-model="drawerMobile"
      fixed
      temporary
    >
      <template  v-slot:prepend>
        <div class="pa-2">
          <v-btn
            text
            block
            color="primary"
            @click.stop="drawerMobile = !drawerMobile"
          >
            <v-icon left>mdi-chevron-left</v-icon>
            thu vào
          </v-btn>
        </div>
      </template>
      <v-list class="side-menu">
        <v-list-item-group
          v-model="selectedMenuItem"
          color="primary"
        >
        <!-- :to="`/${$route.params.lang || sysCode}${item.to}`" -->
          <template v-for="(item, index) in menu.web">
            <v-divider v-if="index > 0"/>
            <v-list-item 
              :key="`menu_mobile${index}`" 
              :to="item.to"
              link
            >
              <v-list-item-icon>
                <v-icon>{{item.action}}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{item.title}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn 
            v-if="isLogged" 
            block 
            color="error"
            @click="logout()"
          >
            Đăng xuất
          </v-btn>
          <v-btn 
            v-else 
            block 
            color="primary"
            @click="login"
          >
            Đăng nhập
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-navigation-drawer 
      app
      fixed
      height="100%"
      v-model="drawer"
      :mini-variant="mini"
      mini-variant-width="200"
      id="sidebar"
      floating
    >
      <template 
        v-slot:prepend 
      >
        <v-list-item two-line class="mt-3">
          <router-link to="/">
            <v-img
              alt="Agri portal Logo"
              class="shrink"
              contain
              src="@/assets/agriportal-logo-v2.png"
              transition="scale-transition"
              :width="100"
            />
          </router-link>
        </v-list-item>
      </template>
      <v-list dense class="side-menu mt-2">
        <v-list-item-group
          v-model="selectedMenuItem"
          color="primary"
        >
          <v-list-item 
            v-for="(item, index) in menu.web" 
            :key="`menu${index}`"
            class="text-center pa-0 pt-3 pb-2 leaf-menu " 
            link 
            :to="item.to"
          >
            <span>
              <v-icon style="font-size: 30px;">{{item.action}}</v-icon>
              <v-subheader class="menu-name">{{item.title}}</v-subheader> 
            </span>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main id="frontMain">
      <div 
        class="d-flex flex-column"
        :class="{'fill-height' : !showHeaderSlider}"
      >
        <v-container fluid>
          <v-alert
            v-if="errors_exist"
            dismissible
            type="error"
            class="rounded-0"
          >
            {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
            <ul v-if="errors">
              <div 
                v-for="(error, index) in errors" 
                :key="`err${index}`"
              >
                <li>{{ error[0] }}</li>
              </div>
            </ul>
          </v-alert>
          <router-view/>
        </v-container>
      </div>
    </v-main>
    <Footer :sysName="sysName"/>
    <ScrollTop/>
    <ChangePassword 
      :showDialog="dialogChangePassword" 
      :item="itemChangePassword" 
      @confirmed="onChangePasswordConfirmed" 
      @cancelled="onChangePasswordCancelled"
    />
    <Profile 
      v-if="isLogged"
      :loading="profileLoading"
      :showDialog="profileDialog" 
      :item="userProfile" 
      @confirmed="onProfileConfirmed" 
      @cancelled="onProfileCancelled"
    />
  </v-app>
</template>
<script>
  import { mapGetters, mapState, mapActions } from 'vuex'
  import Module from '@/components/public/home/Module'
  import Footer from '@/components/public/layouts/Footer'
  import ScrollTop from '@/components/public/layouts/ScrollTop'
  import ChangePassword from '@/views/auth/password/ChangePassword'
  import Profile from '@/views/user/Profile'
  export default {
    components: {
      Module,
      Footer,
      ScrollTop,
      ChangePassword,
      Profile
    },
    data() {
      return {
        keyword: '',
        drawer: null,
        drawerMobile: false,
        mini: true,
        errors_exist: false,
        errors: [],
        searchClosed: true,
        selectedMenuItem: null,
        adminRouteName: null,
        dialogChangePassword: false,
        itemChangePassword: {},
        profileLoading: false,
        profileDialog: false,
        userProfile: {},
        isChuyenGia: false,
      }
    },
    watch: {
      errors_exist(){
        window.scrollTo(0,0);
      }
    },
    computed: {
      ...mapGetters([
        'isLogged'
      ]),
      ...mapState([
        'user', 
        'system', 
        'menu', 
        'authMod', 
        'contactCounter',
        'qasNotRespCounter',
        'config',
        'loader',
        'showHeaderSlider'
      ]),
      apiBaseUrl() {
        return this.config.beUrl;
      },
      sysName() {
        return this.system ? this.system.ten : '';
      },
      sysCode() {
        return this.config.sysCodeDefault;
      }
    },
    mounted() {
      this.getSystem();
      this.$store.commit('setLoginRequest', false)
      if(this.isLogged){
        this.countContact();

        if(this.$role('supper-admin') 
          || this.$role('so-nong-nghiep') 
          || this.$role('ql-chat-luong')
        ){
          this.adminRouteName = 'Dashboard'
        } else if (this.$role('chuyen-gia')) {
          this.adminRouteName = 'ExpertMailBox'
          this.isChuyenGia = true
          this.countQasNotResp(this.authMod.user.user.info.coso_id)
        }
      }
    },
    methods: {
      ...mapActions([
        'toggleDrawer',
        'getSystem',
        'countContact',
        'countQasNotResp',
        'logout'
      ]),
      login() {
        this.$router.push({ name: 'Login' })
      },
      reload(){
        this.$router.go()
      },
      search(){
        this.$router.push({
          name: 'Search', 
          params: { keyword: this.keyword }
        });
      },
      changePassword(){
        this.itemChangePassword = {}
        this.dialogChangePassword = true
      },
      onChangePasswordConfirmed(item) {
        this.dialogChangePassword = false
      },
      onChangePasswordCancelled () {
        this.dialogChangePassword = false 
      },
      showProfileDialog(){
        this.profileLoading = true
        axios.get(`api/v1/users/${this.authMod.user.user.id}`)
          .then(response => {
            this.userProfile = response.data;
            this.profileLoading = false
            this.profileDialog = true
          })
          .catch(function (error) {
            console.log(error);
            this.profileLoading = false
          });
      },
      onProfileConfirmed(item) {
        this.profileDialog = false 
      },
      onProfileCancelled () {
        this.profileDialog = false 
      },
    }
  }
</script>

<style>
  #frontMain.v-main{
    background-color: rgb(241 241 241);
  }
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(112, 112, 112, 0.3); 
    border-radius: 20px;
    opacity: 0.28;
  }

  .scroll-custom-primary::-webkit-scrollbar-thumb {
    background: #00796b4b !important; 
  }

  ::-webkit-scrollbar-thumb:hover{
    background-color: #666666;
  }

  .scroll-custom-primary::-webkit-scrollbar-thumb:hover{
    background-color: #00796b !important;
  }
  ::-webkit-scrollbar-button {
    display:none;
  }
  .side-menu .menu-name{
    color: #000000;
    font-size: 16px !important;
    line-height: 1.5 !important;
  }
  .side-menu .v-item--active .menu-name{
    color: var(--v-primary-base);
  }
</style>

<style lang="scss" scoped>
  @mixin ballb($yaxis: 0) {
    transform: translate3d(0, $yaxis, 0);
  }

  @keyframes bouncein {
    0%, 50% { @include ballb(-3px); }
    25%, 75%, 100% { @include ballb() }
  }

  .bounce {
    animation: bouncein 1500ms cubic-bezier(0.25, 0.46, 0.45, 0.94) both infinite;
  }
</style>